@file:OptIn(InternalResourceApi::class)

package ru.ivk1800.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/ru.ivk1800.resources/"

internal val Res.string.app_title: StringResource by lazy {
      StringResource("string:app_title", "app_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 53),
      ))
    }

internal val Res.string.avoid_unnecessary_state_reads_1_good_explanation: StringResource by lazy {
      StringResource("string:avoid_unnecessary_state_reads_1_good_explanation", "avoid_unnecessary_state_reads_1_good_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 10, 880),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64, 584),
      ))
    }

internal val Res.string.avoid_unnecessary_state_reads_1_good_title: StringResource by lazy {
      StringResource("string:avoid_unnecessary_state_reads_1_good_title", "avoid_unnecessary_state_reads_1_good_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 649, 130),
      ))
    }

internal val Res.string.avoid_unnecessary_state_reads_2_good_explanation: StringResource by lazy {
      StringResource("string:avoid_unnecessary_state_reads_2_good_explanation", "avoid_unnecessary_state_reads_2_good_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 891, 884),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 780, 576),
      ))
    }

internal val Res.string.avoid_unnecessary_state_reads_2_good_title: StringResource by lazy {
      StringResource("string:avoid_unnecessary_state_reads_2_good_title", "avoid_unnecessary_state_reads_2_good_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1357, 130),
      ))
    }

internal val Res.string.avoid_unnecessary_state_reads_bad_explanation: StringResource by lazy {
      StringResource("string:avoid_unnecessary_state_reads_bad_explanation", "avoid_unnecessary_state_reads_bad_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 1776, 925),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1488, 565),
      ))
    }

internal val Res.string.avoid_unnecessary_state_reads_bad_title: StringResource by lazy {
      StringResource("string:avoid_unnecessary_state_reads_bad_title", "avoid_unnecessary_state_reads_bad_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2054, 87),
      ))
    }

internal val Res.string.build_info: StringResource by lazy {
      StringResource("string:build_info", "build_info", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2142, 34),
      ))
    }

internal val Res.string.compose_version: StringResource by lazy {
      StringResource("string:compose_version", "compose_version", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2177, 43),
      ))
    }

internal val Res.string.composition_local_explanation: StringResource by lazy {
      StringResource("string:composition_local_explanation", "composition_local_explanation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2221, 273),
      ))
    }

internal val Res.string.composition_local_title: StringResource by lazy {
      StringResource("string:composition_local_title", "composition_local_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2495, 123),
      ))
    }

internal val Res.string.derived_state_of_bad_explanation: StringResource by lazy {
      StringResource("string:derived_state_of_bad_explanation", "derived_state_of_bad_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 2702, 1448),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2619, 768),
      ))
    }

internal val Res.string.derived_state_of_bad_title: StringResource by lazy {
      StringResource("string:derived_state_of_bad_title", "derived_state_of_bad_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3388, 114),
      ))
    }

internal val Res.string.derived_state_of_explanation: StringResource by lazy {
      StringResource("string:derived_state_of_explanation", "derived_state_of_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 4151, 904),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3503, 548),
      ))
    }

internal val Res.string.derived_state_of_title: StringResource by lazy {
      StringResource("string:derived_state_of_title", "derived_state_of_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4052, 90),
      ))
    }

internal val Res.string.explanation: StringResource by lazy {
      StringResource("string:explanation", "explanation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4143, 35),
      ))
    }

internal val Res.string.how_good: StringResource by lazy {
      StringResource("string:how_good", "how_good", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4179, 32),
      ))
    }

internal val Res.string.immutable_type_explanation: StringResource by lazy {
      StringResource("string:immutable_type_explanation", "immutable_type_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 5056, 1454),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4212, 882),
      ))
    }

internal val Res.string.immutable_type_title: StringResource by lazy {
      StringResource("string:immutable_type_title", "immutable_type_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5095, 96),
      ))
    }

internal val Res.string.kotlin_version: StringResource by lazy {
      StringResource("string:kotlin_version", "kotlin_version", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5192, 38),
      ))
    }

internal val Res.string.lambda_modifiers_good_explanation: StringResource by lazy {
      StringResource("string:lambda_modifiers_good_explanation", "lambda_modifiers_good_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 6511, 1221),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5231, 677),
      ))
    }

internal val Res.string.lambda_modifiers_good_title: StringResource by lazy {
      StringResource("string:lambda_modifiers_good_title", "lambda_modifiers_good_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5909, 135),
      ))
    }

internal val Res.string.launch_effect_key_bad_explanation: StringResource by lazy {
      StringResource("string:launch_effect_key_bad_explanation", "launch_effect_key_bad_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 7733, 1817),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6045, 941),
      ))
    }

internal val Res.string.launch_effect_key_bad_title: StringResource by lazy {
      StringResource("string:launch_effect_key_bad_title", "launch_effect_key_bad_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6987, 119),
      ))
    }

internal val Res.string.launch_effect_key_good_explanation: StringResource by lazy {
      StringResource("string:launch_effect_key_good_explanation", "launch_effect_key_good_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 9551, 1138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7107, 606),
      ))
    }

internal val Res.string.launch_effect_key_good_title: StringResource by lazy {
      StringResource("string:launch_effect_key_good_title", "launch_effect_key_good_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7714, 104),
      ))
    }

internal val Res.string.launch_effect_with_key_explanation: StringResource by lazy {
      StringResource("string:launch_effect_with_key_explanation", "launch_effect_with_key_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 10690, 562),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7819, 362),
      ))
    }

internal val Res.string.launch_effect_with_key_title: StringResource by lazy {
      StringResource("string:launch_effect_with_key_title", "launch_effect_with_key_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8182, 84),
      ))
    }

internal val Res.string.launch_effect_without_key_explanation: StringResource by lazy {
      StringResource("string:launch_effect_without_key_explanation", "launch_effect_without_key_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 11253, 601),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8267, 381),
      ))
    }

internal val Res.string.launch_effect_without_key_title: StringResource by lazy {
      StringResource("string:launch_effect_without_key_title", "launch_effect_without_key_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8649, 127),
      ))
    }

internal val Res.string.lazy_list_with_key_good: StringResource by lazy {
      StringResource("string:lazy_list_with_key_good", "lazy_list_with_key_good", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9805, 123),
      ))
    }

internal val Res.string.lazy_list_with_key_good_explanation: StringResource by lazy {
      StringResource("string:lazy_list_with_key_good_explanation", "lazy_list_with_key_good_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 11855, 1919),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8777, 1027),
      ))
    }

internal val Res.string.lazy_list_without_key_bad_explanation: StringResource by lazy {
      StringResource("string:lazy_list_without_key_bad_explanation", "lazy_list_without_key_bad_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 13775, 997),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9929, 565),
      ))
    }

internal val Res.string.lazy_list_without_key_bad_title: StringResource by lazy {
      StringResource("string:lazy_list_without_key_bad_title", "lazy_list_without_key_bad_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10495, 123),
      ))
    }

internal val Res.string.movable_content_of_explanation: StringResource by lazy {
      StringResource("string:movable_content_of_explanation", "movable_content_of_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 14773, 786),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10619, 486),
      ))
    }

internal val Res.string.movable_content_of_title: StringResource by lazy {
      StringResource("string:movable_content_of_title", "movable_content_of_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11106, 96),
      ))
    }

internal val Res.string.not_lambda_modifiers_bad_explanation: StringResource by lazy {
      StringResource("string:not_lambda_modifiers_bad_explanation", "not_lambda_modifiers_bad_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 15560, 704),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11203, 440),
      ))
    }

internal val Res.string.not_lambda_modifiers_bad_title: StringResource by lazy {
      StringResource("string:not_lambda_modifiers_bad_title", "not_lambda_modifiers_bad_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11644, 146),
      ))
    }

internal val Res.string.read_state_bad_explanation: StringResource by lazy {
      StringResource("string:read_state_bad_explanation", "read_state_bad_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 16265, 982),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11791, 562),
      ))
    }

internal val Res.string.read_state_bad_title: StringResource by lazy {
      StringResource("string:read_state_bad_title", "read_state_bad_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12354, 124),
      ))
    }

internal val Res.string.read_state_good_explanation: StringResource by lazy {
      StringResource("string:read_state_good_explanation", "read_state_good_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 17248, 767),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12479, 423),
      ))
    }

internal val Res.string.read_state_good_title: StringResource by lazy {
      StringResource("string:read_state_good_title", "read_state_good_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12903, 105),
      ))
    }

internal val Res.string.riflesso_title: StringResource by lazy {
      StringResource("string:riflesso_title", "riflesso_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13009, 178),
      ))
    }

internal val Res.string.static_composition_local_explanation: StringResource by lazy {
      StringResource("string:static_composition_local_explanation", "static_composition_local_explanation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13188, 532),
      ))
    }

internal val Res.string.static_composition_local_title: StringResource by lazy {
      StringResource("string:static_composition_local_title", "static_composition_local_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13721, 150),
      ))
    }

internal val Res.string.unstable_type_explanation: StringResource by lazy {
      StringResource("string:unstable_type_explanation", "unstable_type_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 18016, 1193),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13872, 745),
      ))
    }

internal val Res.string.unstable_type_title: StringResource by lazy {
      StringResource("string:unstable_type_title", "unstable_type_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14618, 87),
      ))
    }

internal val Res.string.with_remember_updated_state_explanation: StringResource by lazy {
      StringResource("string:with_remember_updated_state_explanation", "with_remember_updated_state_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 19210, 871),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14706, 527),
      ))
    }

internal val Res.string.with_remember_updated_state_title: StringResource by lazy {
      StringResource("string:with_remember_updated_state_title", "with_remember_updated_state_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15234, 165),
      ))
    }

internal val Res.string.without_remember_updated_state_explanation: StringResource by lazy {
      StringResource("string:without_remember_updated_state_explanation", "without_remember_updated_state_explanation", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 20082, 658),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15400, 434),
      ))
    }

internal val Res.string.without_remember_updated_state_title: StringResource by lazy {
      StringResource("string:without_remember_updated_state_title", "without_remember_updated_state_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15835, 120),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_title", Res.string.app_title)
  map.put("avoid_unnecessary_state_reads_1_good_explanation", Res.string.avoid_unnecessary_state_reads_1_good_explanation)
  map.put("avoid_unnecessary_state_reads_1_good_title", Res.string.avoid_unnecessary_state_reads_1_good_title)
  map.put("avoid_unnecessary_state_reads_2_good_explanation", Res.string.avoid_unnecessary_state_reads_2_good_explanation)
  map.put("avoid_unnecessary_state_reads_2_good_title", Res.string.avoid_unnecessary_state_reads_2_good_title)
  map.put("avoid_unnecessary_state_reads_bad_explanation", Res.string.avoid_unnecessary_state_reads_bad_explanation)
  map.put("avoid_unnecessary_state_reads_bad_title", Res.string.avoid_unnecessary_state_reads_bad_title)
  map.put("build_info", Res.string.build_info)
  map.put("compose_version", Res.string.compose_version)
  map.put("composition_local_explanation", Res.string.composition_local_explanation)
  map.put("composition_local_title", Res.string.composition_local_title)
  map.put("derived_state_of_bad_explanation", Res.string.derived_state_of_bad_explanation)
  map.put("derived_state_of_bad_title", Res.string.derived_state_of_bad_title)
  map.put("derived_state_of_explanation", Res.string.derived_state_of_explanation)
  map.put("derived_state_of_title", Res.string.derived_state_of_title)
  map.put("explanation", Res.string.explanation)
  map.put("how_good", Res.string.how_good)
  map.put("immutable_type_explanation", Res.string.immutable_type_explanation)
  map.put("immutable_type_title", Res.string.immutable_type_title)
  map.put("kotlin_version", Res.string.kotlin_version)
  map.put("lambda_modifiers_good_explanation", Res.string.lambda_modifiers_good_explanation)
  map.put("lambda_modifiers_good_title", Res.string.lambda_modifiers_good_title)
  map.put("launch_effect_key_bad_explanation", Res.string.launch_effect_key_bad_explanation)
  map.put("launch_effect_key_bad_title", Res.string.launch_effect_key_bad_title)
  map.put("launch_effect_key_good_explanation", Res.string.launch_effect_key_good_explanation)
  map.put("launch_effect_key_good_title", Res.string.launch_effect_key_good_title)
  map.put("launch_effect_with_key_explanation", Res.string.launch_effect_with_key_explanation)
  map.put("launch_effect_with_key_title", Res.string.launch_effect_with_key_title)
  map.put("launch_effect_without_key_explanation", Res.string.launch_effect_without_key_explanation)
  map.put("launch_effect_without_key_title", Res.string.launch_effect_without_key_title)
  map.put("lazy_list_with_key_good", Res.string.lazy_list_with_key_good)
  map.put("lazy_list_with_key_good_explanation", Res.string.lazy_list_with_key_good_explanation)
  map.put("lazy_list_without_key_bad_explanation", Res.string.lazy_list_without_key_bad_explanation)
  map.put("lazy_list_without_key_bad_title", Res.string.lazy_list_without_key_bad_title)
  map.put("movable_content_of_explanation", Res.string.movable_content_of_explanation)
  map.put("movable_content_of_title", Res.string.movable_content_of_title)
  map.put("not_lambda_modifiers_bad_explanation", Res.string.not_lambda_modifiers_bad_explanation)
  map.put("not_lambda_modifiers_bad_title", Res.string.not_lambda_modifiers_bad_title)
  map.put("read_state_bad_explanation", Res.string.read_state_bad_explanation)
  map.put("read_state_bad_title", Res.string.read_state_bad_title)
  map.put("read_state_good_explanation", Res.string.read_state_good_explanation)
  map.put("read_state_good_title", Res.string.read_state_good_title)
  map.put("riflesso_title", Res.string.riflesso_title)
  map.put("static_composition_local_explanation", Res.string.static_composition_local_explanation)
  map.put("static_composition_local_title", Res.string.static_composition_local_title)
  map.put("unstable_type_explanation", Res.string.unstable_type_explanation)
  map.put("unstable_type_title", Res.string.unstable_type_title)
  map.put("with_remember_updated_state_explanation", Res.string.with_remember_updated_state_explanation)
  map.put("with_remember_updated_state_title", Res.string.with_remember_updated_state_title)
  map.put("without_remember_updated_state_explanation", Res.string.without_remember_updated_state_explanation)
  map.put("without_remember_updated_state_title", Res.string.without_remember_updated_state_title)
}
